































































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import userModule from '@/model/store/modules/user-module';
import contentsModule from '@/model/store/modules/contents-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import contentsService from '@/model/services/contents-service';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes} from '@/model/dto/res/contents/get-category-list-res';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class SearchTab extends Vue {
  /** Data **/
  private tabs: string | null = null;
  private tab: string | null = null;
  private title: string = '';
  private tabNo: number = 3;

  /** Computed **/
  set titleValue(val: string) {
    this.title = val;
  }

  get titleValue() {
    return appModule.searchKeyword !== '' ? appModule.searchKeyword : this.title;
  }

  get categoryInfo() {
    return appModule.categoryInfo;
  }

  get contents() {
    return detailModule.contents;
  }

  get breadCrumbs() {
    return detailModule.breadcrumbs;
  }

  get text() {
    return {
      search: GlobalConstants.TEXT.SEARCH
    };
  }

  /** Methods **/
  private async onSearch() {
    appModule.updateSearchKeyword(this.title);
    await appModule.requestCategoryInfo({
      q: this.title,
      s: 0,
      o: 'dp'
    }).catch(err => {
      this.errorPropagation(err);
    });
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

}
